import { Heart, MessageCircle } from 'lucide-react';

interface PhotoGridProps {
    photos?: string[]; // Mock data for now
}

export function PhotoGrid({ photos }: PhotoGridProps) {
    // Generate some mock placeholder images if none provided
    const mockPhotos = photos || Array.from({ length: 9 }).map((_, i) => ({
        id: i,
        url: `https://picsum.photos/seed/${i + 42}/400/400`, // Consistent seeds
        likes: Math.floor(Math.random() * 500) + 50,
        comments: Math.floor(Math.random() * 20),
    }));

    return (
        <div className="grid grid-cols-3 gap-1 md:gap-4">
            {mockPhotos.map((photo: any) => (
                <div
                    key={photo.id}
                    className="aspect-square relative group cursor-pointer overflow-hidden bg-bg-surface md:rounded-2xl"
                >
                    <img
                        src={photo.url}
                        alt="Post"
                        className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                        loading="lazy"
                    />

                    {/* Premium Hover Overlay */}
                    <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col justify-end p-4">
                        <div className="flex items-center justify-center gap-6 text-white font-bold transform translate-y-4 group-hover:translate-y-0 transition-transform duration-300">
                            <div className="flex items-center gap-2">
                                <Heart size={20} className="fill-white drop-shadow-md" />
                                <span className="drop-shadow-md">{photo.likes}</span>
                            </div>
                            <div className="flex items-center gap-2">
                                <MessageCircle size={20} className="fill-white drop-shadow-md" />
                                <span className="drop-shadow-md">{photo.comments}</span>
                            </div>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
}
